import ErrorComponent from "Components/ErrorComponent";
import Loading from "Components/Loading";
import Layout from "HorizontalMenu/Menu";
import { loadFleetVessels, loadFleets } from "VesselMaster/vesselMaster.hooks";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import {
    Navbar,
    Container,
    Row,
    Col,
    Button,
    Label,
    Modal,
    Form,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import { queryKeyes } from "shared/queryKeys";
import CreateFleet from "./CreateFleet";
import { queryClient } from "react-query/queryClient";
import ToolTip from "Components/ToolTip";
import { errorToast, successToast } from "Components/Toasts";
import { Field, FieldArray, Formik } from "formik";
import FormValuesDebug from "utils/debugTools/FormValuesDebug";
import { errResponse } from "GenericForms/Helper";
import apiGlobal from "global/api.global";
import DeletePopOver from "Components/DeletePopOver";
import { RootState } from "index";
import { useDispatch, useSelector } from "react-redux";
import { getVesselsAction } from "Store/Generic/ReportingSlice";
import classnames from "classnames";
import CIICategoryChart from "./CIICategoryChart";
import VesselTypesCategoryChart from "./VesselTypesCategoryChart";
import FleetAssessmentTable from "./FleetAssessmentTable";

const Fleets = () => {
    /** State variables */
    const [createModalState, setCreateModalState] = useState(false);
    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const [searchString, setSearchString] = useState("");
    const search = useRef();
    const [searchedArray, setSearchedArray] = useState<Array<any>>([]);
    const { Vessels } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();
    const ApplicableVessels: any = Vessels.filter(
        (vessel: any) => vessel.display === true
    );
    const [popoverState, setPopoverState] = useState(false);
    const [verticalActiveTab, setverticalActiveTab] = useState("1");
    const [fleetGraph, setFleetGraph] = useState<any>({});
    /** State variables end */

    /** Queries */
    /** Fleets */
    const {
        data: Fleets,
        isLoading: FleetsLoading,
        isError: FleetsError,
    } = useQuery(
        [queryKeyes.masters.Fleets.key],
        async () => {
            return await loadFleets();
        },
        {
            enabled: true,
        }
    );
    const [fleetId, setFleetId] = useState(
        Fleets?.filter((item: any) => item.display === true)[0]?.id
    );
    /** Load fleet's vessels */
    const {
        data: FleetVessels,
        isLoading: FleetVesselsLoading,
        isError: FleetVesselsError,
    } = useQuery(
        [queryKeyes.masters.FleetVessels.key],
        async () => {
            return await loadFleetVessels();
        },
        {
            enabled: true,
        }
    );
    /** Queries end */

    const InvalidateFleets = () => {
        queryClient.invalidateQueries([queryKeyes.masters.Fleets.key]);
    };

    /** Open-close modal */
    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    /** Change tabs */
    const toggleVertical = (tab: any) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };

    /** Vessel label onClick function */
    const handleVesselLabelChanges = (
        values: any,
        field: string,
        index: number,
        setFieldValue: any,
        vessel: any
    ) => {
        if (
            values[
                values.findIndex((item: any) => item.vessel_id === vessel.vessel_id)
            ]?.vessel_checkbox === false
        ) {
            setFieldValue(
                `${values.findIndex(
                    (item: any) => item.vessel_id === vessel.vessel_id
                )}.vessel_checkbox`,
                true
            );
        } else {
            setFieldValue(
                `${values.findIndex(
                    (item: any) => item.vessel_id === vessel.vessel_id
                )}.vessel_checkbox`,
                false
            );
        }
        setFieldValue(`${0}.search`, "");
        setSearchedArray(null);
    };

    /** Assign initial values to formik component */
    const getInitialValues = () => {
        let arr: any[] = [];
        if (
            FleetVessels?.length > 0 &&
            FleetVessels[0].id > 0 &&
            arr.length <=
            FleetVessels?.filter((item: any) => item.fleet_id === fleetId).length +
            ApplicableVessels?.filter((item: any) => {
                return !FleetVessels.some(
                    (fleetItem: any) =>
                        fleetItem.vessel_id === item.id &&
                        fleetItem.fleet_id === fleetId
                );
            }).length
        ) {
            FleetVessels.filter((item: any) => item.fleet_id === fleetId).map(
                (fleet: any) => {
                    arr?.push({
                        fleet_id: fleetId,
                        vessel_checkbox: fleet.vessel_checkbox,
                        vessel_id: fleet.vessel_id,
                        vessel_name: fleet.vessel_name,
                        search: "",
                    });
                    return "";
                }
            );
            ApplicableVessels?.filter((item: any) => {
                return !FleetVessels.some(
                    (fleetItem: any) =>
                        fleetItem.vessel_id === item.id && fleetItem.fleet_id === fleetId
                );
            }).map((vessel: any) => {
                return arr?.push({
                    fleet_id: fleetId,
                    vessel_checkbox: false,
                    vessel_id: vessel.id,
                    vessel_name: vessel.vessel_name,
                    search: "",
                });
            });
            return arr;
        } else {
            ApplicableVessels?.map((vessel: any) => {
                return arr?.push({
                    fleet_id: fleetId,
                    vessel_checkbox: false,
                    vessel_id: vessel.id,
                    vessel_name: vessel.vessel_name,
                    search: "",
                });
            });
            return arr;
        }
    };

    /** useEffect start */
    useEffect(() => {
        FleetFormik.initialValues = getInitialValues();
    }, [ApplicableVessels, fleetId, FleetVessels]);
    /** Populate Vessels array */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master" as string));
    }, [dispatch]);
    /** Set fleetId */
    useEffect(() => {
        setFleetId(Fleets?.filter((item: any) => item.display === true)[0]?.id);
    }, [Fleets]);
    /** Load graph data */
    useEffect(() => {
        const loadData = async () => {
            await apiGlobal
                .get(`cii_graph/categorize_records/?fleet_id=${fleetId}`)
                .then((response) => {
                    setFleetGraph(response.data);
                    return response.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        };
        loadData();
    }, [fleetId]);
    /** useEffect end */

    /** Formik component for fleet */
    const FleetFormik = {
        initialValues: getInitialValues(),
    };

    /** Function to delete fleet */
    const handleFleetDelete = (id: number) => {
        apiGlobal
            .delete(`/fleet_master/${id}/`)
            .then((res) => {
                if (res.status === 200 || res.status === 204) {
                    successToast("Data deleted successfully!");
                    InvalidateFleets();
                    setPopoverState(false);
                }
            })
            .catch((err) => {
                if (errResponse.includes(err.response.status)) {
                    errorToast("Internal error occured, please contact the admin");
                }
            });
    };

    /** Search functionality */
    const handleSearchTextboxChanges = (searchValue: string, values: any) => {
        let arr: any[] = FleetFormik.initialValues;
        arr = arr.filter((fleet: any) =>
            fleet?.vessel_name?.toLowerCase().includes(searchValue?.toLowerCase())
        );
        if (
            !(searchValue === "" || searchValue === null || searchValue === undefined)
        ) {
            setSearchedArray(arr);
        } else if (!searchValue) {
            setSearchedArray(null);
        }
    };

    return (
        <React.Fragment>
            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    {(FleetsLoading || FleetVesselsLoading) && (
                        <Loading message="Loading required data!" />
                    )}
                    {FleetsError && (
                        <ErrorComponent message="Unable to load required data!" />
                    )}
                    {FleetVesselsError && getInitialValues()}
                    {!(FleetsLoading || FleetVesselsLoading) && !FleetsError && (
                        <>
                            <Row className="mb-2">
                                <Col lg={{ size: 2, offset: 10 }}>
                                    <Button
                                        color="primary"
                                        className="btn btn-primary justify_right"
                                        onClick={() => setCreateModalState(true)}
                                    >
                                        <i className="dripicons-plus font-size-16 align-middle me-2" />
                                        Create New
                                    </Button>
                                    <CreateFleet
                                        state={createModalState}
                                        setState={setCreateModalState}
                                        invalidate={InvalidateFleets}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">
                                    {Fleets.filter((item: any) => item.display === true)
                                        .length === 0 ? (
                                        <Label>No fleets to display</Label>
                                    ) : (
                                        Fleets.filter((item: any) => item.display === true).map(
                                            (fleet: any, index: number) => {
                                                return (
                                                    <Nav key={index} pills className="flex-column">
                                                        <NavItem>
                                                            <NavLink
                                                                style={{ cursor: "pointer" }}
                                                                className={classnames({
                                                                    "mb-2": true,
                                                                    active: verticalActiveTab === `${fleet.id}`,
                                                                })}
                                                                onClick={() => {
                                                                    setFleetId(fleet.id);
                                                                    toggleVertical(`${fleet.id}`);
                                                                }}
                                                            >
                                                                {fleet.fleet_name}
                                                            </NavLink>
                                                        </NavItem>
                                                    </Nav>
                                                );
                                            }
                                        )
                                    )}
                                </Col>
                                <Col md="9">
                                    {Fleets?.filter((item: any) => item.id === fleetId).map(
                                        (fleet: any, index: number) => {
                                            return (
                                                <TabContent
                                                    key={index}
                                                    activeTab={verticalActiveTab}
                                                    className="text-muted mt-4 mt-md-0"
                                                >
                                                    <TabPane key={index} tabId={`${fleetId}`}>
                                                        <Row>
                                                            <Col lg={{ size: 2, offset: 10 }}>
                                                                <i
                                                                    className="bx bx-edit icon_s23 ms-5"
                                                                    id="add_vessels"
                                                                    onClick={() => {
                                                                        setFleetId(fleet.id);
                                                                        tog_backdrop();
                                                                    }}
                                                                />
                                                                {FleetVessels.filter(
                                                                    (item: any) =>
                                                                        item.fleet_id === fleet.id &&
                                                                        fleet.vessel_checkbox === true
                                                                ).length === 0 && (
                                                                        <>
                                                                            <i
                                                                                className="dripicons-trash icon_s18 pos-end"
                                                                                id="delete_fleet"
                                                                                onClick={() => setPopoverState(true)}
                                                                            />
                                                                            <ToolTip
                                                                                target="delete_fleet"
                                                                                message={`Delete ${fleet.fleet_name}`}
                                                                            />
                                                                            <DeletePopOver
                                                                                target="delete_fleet"
                                                                                onClick={() =>
                                                                                    handleFleetDelete(fleet.id)
                                                                                }
                                                                                state={popoverState}
                                                                                setState={setPopoverState}
                                                                            />
                                                                        </>
                                                                    )}
                                                            </Col>
                                                        </Row>
                                                        {fleetGraph &&
                                                            fleetGraph?.grade_counts?.a === 0 &&
                                                            fleetGraph?.grade_counts?.b === 0 &&
                                                            fleetGraph?.grade_counts?.c === 0 &&
                                                            fleetGraph?.grade_counts?.d === 0 &&
                                                            fleetGraph?.grade_counts?.e === 0 &&
                                                            fleetGraph?.type_grade_counts?.length <= 0 &&
                                                            fleetGraph?.vessel_data?.length <= 0 ? (
                                                            <Row>
                                                                <strong className="text-center">
                                                                    No data available
                                                                </strong>
                                                            </Row>
                                                        ) : (
                                                            <>
                                                                <Row className="mb-5">
                                                                    <Col lg={6}>
                                                                        {fleetId > 0 && (
                                                                            <CIICategoryChart
                                                                                graphData={fleetGraph?.grade_counts}
                                                                            />
                                                                        )}
                                                                    </Col>
                                                                    <Col lg={6}>
                                                                        <VesselTypesCategoryChart
                                                                            graphData={fleetGraph?.type_grade_counts}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <FleetAssessmentTable
                                                                        graphData={fleetGraph?.vessel_data}
                                                                    />
                                                                </Row>
                                                            </>
                                                        )}
                                                    </TabPane>
                                                </TabContent>
                                            );
                                        }
                                    )}
                                </Col>
                            </Row>
                            <Modal
                                isOpen={modal_backdrop}
                                toggle={() => {
                                    tog_backdrop();
                                }}
                                backdrop={"static"}
                                id="staticBackdrop"
                                size="lg"
                            >
                                <div className="modal-header p-2">
                                    <h5 className="modal-title" id="staticBackdropLabel">
                                        Add/remove vessels from{" "}
                                        {
                                            Fleets?.filter((item: any) => item.id === fleetId)[0]
                                                ?.fleet_name
                                        }
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setSearchedArray(null);
                                            setmodal_backdrop(false);
                                        }}
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div className="minHeight15">
                                        <Formik
                                            onSubmit={(values: any, actions: any) => {
                                                actions.setSubmitting(false);
                                                const handleResponse = (response: any) => {
                                                    if (
                                                        response.status === 201 ||
                                                        response.status === 200
                                                    ) {
                                                        successToast("Data saved successfully!");
                                                        queryClient.invalidateQueries(
                                                            queryKeyes.masters.Fleets.key
                                                        );
                                                        queryClient.invalidateQueries(
                                                            queryKeyes.masters.FleetVessels.key
                                                        );
                                                        setmodal_backdrop(false);
                                                    }
                                                };
                                                apiGlobal
                                                    .post(`/fleet_vessel/`, values)
                                                    .then((res) => {
                                                        handleResponse(res);
                                                    })
                                                    .catch((err) => {
                                                        if (errResponse.includes(err.response.status)) {
                                                            errorToast(
                                                                "Internal error occured, please contact the admin"
                                                            );
                                                        }
                                                    });
                                            }}
                                            initialValues={FleetFormik.initialValues}
                                        >
                                            {(props) => (
                                                <Form onSubmit={props.handleSubmit} autoComplete="off">
                                                    <Row>
                                                        <div className="p-2">
                                                            <div className="search-box position-relative">
                                                                <Field
                                                                    type="text"
                                                                    className="form-control rounded border"
                                                                    placeholder="Search..."
                                                                    name={`${0}.search`}
                                                                    onChange={(e: any) => {
                                                                        props.handleChange(e);
                                                                        setSearchString(e.target.value);
                                                                        handleSearchTextboxChanges(
                                                                            searchString,
                                                                            props?.values
                                                                        );
                                                                    }}
                                                                    onBlur={(e: any) => {
                                                                        setSearchString(e.target.value);
                                                                        handleSearchTextboxChanges(
                                                                            searchString,
                                                                            props?.values
                                                                        );
                                                                    }}
                                                                    ref={search}
                                                                />
                                                                <i className="bx bx-search search-icon"></i>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                    <FieldArray name="vessels">
                                                        {() => (
                                                            <>
                                                                {searchedArray !== undefined &&
                                                                    searchedArray?.length > 0 &&
                                                                    searchedArray !== null ? (
                                                                    <Row>
                                                                        <Col lg={{ size: 5, offset: 1 }}>
                                                                            {searchedArray?.map(
                                                                                (vessel: any, index: number) => {
                                                                                    return (
                                                                                        <div key={index}>
                                                                                            {vessel.vessel_checkbox === true &&
                                                                                                <Col lg={12} className='mb-2'>
                                                                                                    <div className='ele_row1'>
                                                                                                        <Field
                                                                                                            type='checkbox'
                                                                                                            id='vessel_checkbox'
                                                                                                            name={`${props?.values.findIndex((item: any) => item.vessel_id === vessel.vessel_id)}.vessel_checkbox`}
                                                                                                            className='mr-1'
                                                                                                            onChange={(e: any) => {
                                                                                                                props.handleChange(e);
                                                                                                                setSearchedArray(null);
                                                                                                                props.setFieldValue(`${0}.search`, "");
                                                                                                            }}
                                                                                                            ref={search}
                                                                                                        />
                                                                                                        <Label
                                                                                                            className='text-break mb-0'
                                                                                                            onClick={() =>
                                                                                                                handleVesselLabelChanges(props.values, `${index}.vessel_checkbox`, index, props.setFieldValue, vessel)}>
                                                                                                            {vessel.vessel_name}
                                                                                                        </Label>
                                                                                                    </div>
                                                                                                </Col>
                                                                                            }
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </Col>
                                                                        <Col lg={{ size: 5, offset: 1 }}>
                                                                            {searchedArray?.map(
                                                                                (vessel: any, index: number) => {
                                                                                    return (
                                                                                        <div key={index}>
                                                                                            {vessel.vessel_checkbox === false &&
                                                                                                <Col lg={12} className='mb-2'>
                                                                                                    <div className='ele_row1'>
                                                                                                        <Field
                                                                                                            type='checkbox'
                                                                                                            id='vessel_checkbox'
                                                                                                            name={`${props?.values.findIndex((item: any) => item.vessel_id === vessel.vessel_id)}.vessel_checkbox`}
                                                                                                            className='mr-1'
                                                                                                            onChange={(e: any) => {
                                                                                                                props.handleChange(e);
                                                                                                                setSearchedArray(null);
                                                                                                                props.setFieldValue(`${0}.search`, "");
                                                                                                            }}
                                                                                                            ref={search}
                                                                                                        />
                                                                                                        <Label
                                                                                                            className='text-break mb-0'
                                                                                                            onClick={() =>
                                                                                                                handleVesselLabelChanges(props.values, `${index}.vessel_checkbox`, index, props.setFieldValue, vessel)}>
                                                                                                            {vessel.vessel_name}
                                                                                                        </Label>
                                                                                                    </div>
                                                                                                </Col>
                                                                                            }
                                                                                        </div>
                                                                                    );
                                                                                })}
                                                                        </Col>
                                                                    </Row>) :
                                                                    <Row>
                                                                        <Col lg={5}>
                                                                            {props?.values && props?.values?.map((vessel: any, index: number) => {
                                                                                return (
                                                                                    <div key={index}>
                                                                                        {vessel.vessel_checkbox === true &&
                                                                                            <Col lg={12} className='mb-2'>
                                                                                                <div className='ele_row1'>
                                                                                                    <Field
                                                                                                        type='checkbox'
                                                                                                        id='vessel_checkbox'
                                                                                                        name={`${index}.vessel_checkbox`}
                                                                                                        className='mr-1'
                                                                                                        onChange={(e: any) => {
                                                                                                            props.handleChange(e);
                                                                                                        }}
                                                                                                        defaultValue={props?.values[index]?.vessel_checkbox}
                                                                                                    />
                                                                                                    <Label
                                                                                                        className='text-break mb-0'
                                                                                                        onClick={() =>
                                                                                                            handleVesselLabelChanges(props.values, `${index}.vessel_checkbox`, index, props.setFieldValue, vessel)}>
                                                                                                        {vessel.vessel_name}
                                                                                                    </Label>
                                                                                                </div>
                                                                                            </Col>
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </Col>
                                                                        <Col lg={6}>
                                                                            {props?.values && props?.values?.map((vessel: any, index: number) => {
                                                                                return (
                                                                                    <div key={index}>
                                                                                        {vessel.vessel_checkbox === false &&
                                                                                            <Col lg={12} className='mb-2'>
                                                                                                <div className='ele_row1'>
                                                                                                    <Field
                                                                                                        type='checkbox'
                                                                                                        id='vessel_checkbox'
                                                                                                        name={`${index}.vessel_checkbox`}
                                                                                                        className='mr-1'
                                                                                                        onChange={(e: any) => {
                                                                                                            props.handleChange(e);
                                                                                                        }}
                                                                                                        defaultValue={props?.values[index]?.vessel_checkbox}
                                                                                                    />
                                                                                                    <Label
                                                                                                        className='text-break mb-0'
                                                                                                        onClick={() =>
                                                                                                            handleVesselLabelChanges(props.values, `${index}.vessel_checkbox`, index, props.setFieldValue, vessel)}>
                                                                                                        {vessel.vessel_name}
                                                                                                    </Label>
                                                                                                </div>
                                                                                            </Col>
                                                                                        }
                                                                                    </div>
                                                                                )
                                                                            })
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                }
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                    <Row className="mb-2">
                                                        <Col lg={{ size: 2, offset: 10 }}>
                                                            <Button
                                                                type="submit"
                                                                color="primary"
                                                                className="justify_right mt-3"
                                                            >
                                                                Save
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    <FormValuesDebug
                                                        values={[props.values, props.errors]}
                                                    />
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </div>
                            </Modal>
                        </>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Fleets;
